import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import { useRouter, useSearchParams } from "next/navigation";
import { useAppState } from "../../appContext";
import { useFetchUtilityData } from "../../hooks";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Link from "next/link";

// ⬇️ adjust this import to where your SearchBox lives
import SearchBox from "../SearchBox";

const ResponsiveAppBar = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [state, dispatch] = useAppState();
  const pages = [
    { title: "Events", route: "/events" },
    { title: "Venues", route: "/venues" },
    { title: "Bands", route: "/bands" },
    { title: "Map", route: "/map" },
  ];
  const { utilityData } = useFetchUtilityData();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  React.useEffect(() => {
    if (utilityData) {
      dispatch({
        type: "SET_MULTIPLE_PROPS",
        payload: { states: utilityData.states },
      });
    }
  }, [utilityData, dispatch]);

  return (
    <AppBar sx={{ background: "#334e65", color: "#fff" }} position="sticky">
      <Toolbar
        disableGutters
        sx={{
          gap: 2,
          px: 2,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Logo */}
        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          <Link
            href="/"
            style={{
              textDecoration: "none",
              color: "inherit",
              fontFamily: "monospace",
              fontWeight: 900,
              letterSpacing: ".3rem",
              fontSize: "1.5rem",
              display: "flex",
              alignItems: "center",
              lineHeight: 1,
            }}
          >
            <img
              style={{ height: 55, width: 350, marginRight: 10 }}
              src="/wtlogonew.png"
              alt="Webtunes Logo"
            />
          </Link>
        </Box>

        {/* Nav links */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            columnGap: 1,
            rowGap: isMobile ? 1 : 0,
          }}
        >
          {pages.map((page) => (
            <Button
              key={page.title}
              onClick={() => router.push(page.route)}
              sx={{ color: "#fff" }}
            >
              {page.title}
            </Button>
          ))}
        </Box>

        {/* Search (right on desktop, full width row on mobile) */}
        <Box
          sx={{
            ml: isMobile ? 0 : "auto",
            mr: isMobile ?   0 : 6, 
            width: isMobile ? "100%" : "min(520px, 50%)",
            mt: isMobile ? 1 : 0,
            bgcolor: "#fff",
          }}
        >
          <SearchBox
            fullWidth={true /* keep full width inside the Box */}
            placeholder="Search events, bands, venues…"
            // defaultValue={searchParams.get("q") || ""} // optional: keep current query in header
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default ResponsiveAppBar;
